<template>
  <div>
    <SlideShowSection />
    <AboutSection />
    <ServiceSection />
    <TopicSection />
    <VideoSection />
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import AboutSection from "../components/sections/AboutSection.vue";
import ServiceSection from "../components/sections/ServiceSection.vue";
import TopicSection from "../components/sections/TopicSection.vue";
import VideoSection from "../components/sections/VideoSection.vue";

export default {
  components: {
    SlideShowSection,
    AboutSection,
    ServiceSection,
    TopicSection,
    VideoSection,
  },
};
</script>
